import React from 'react';
import { ensureKeyed } from 'utils';

export default ({links=[]}) =>
  <div className="portal-sub-nav">
    <ul className="header-actions header-actions-left">
      {links
        .map((link) => <li>{link}</li>)
        .map(ensureKeyed())
      }
    </ul>
  </div>;
